import Vue from 'vue'
import bugsnagClient from '@/services/bugsnag'
import bugsnagVue from '@bugsnag/plugin-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { VTooltip } from 'v-tooltip'

const releaseStage = process.env.VUE_APP_ENV || 'development'

bugsnagClient.use(bugsnagVue, Vue)

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

Vue.config.productionTip = false
if (releaseStage === 'development') {
  Vue.config.performance = true
}

Vue.directive('tooltip', VTooltip)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
